<div class="container-fluid">

  <div class="row">
    <div class="col-6">
      <p></p>
    </div>
  </div>

</div>
